import React from "react";
import { FaRegImages } from "react-icons/fa";
import { MdEmojiEvents, MdGroups } from "react-icons/md";
import { RiGalleryFill } from "react-icons/ri";
import { FiYoutube } from "react-icons/fi";
import { GrAnnounce } from "react-icons/gr";
import { BsFillChatQuoteFill } from "react-icons/bs";
import { Link } from "react-router-dom";
import FloatUp from "../../shared/FloatUp";

function AdminHome() {
  return (
    <div className="py-3 container is-fluid">
      {/* Important Stats */}
      <section className="section block">
        <nav className="level">
          <div className="level-item has-text-centered">
            <div>
              <p className="heading">Upcoming Events</p>
              <p className="title">36</p>
            </div>
          </div>
          <div className="level-item has-text-centered">
            <div>
              <p className="heading">Instagram Followers</p>
              <p className="title">420</p>
            </div>
          </div>
          <div className="level-item has-text-centered">
            <div>
              <p className="heading">Page Views</p>
              <p className="title">69</p>
            </div>
          </div>
        </nav>
      </section>
      {/* Buttons for various tasks various tasks */}
      <div className="columns is-multiline is-centered">
        {/* Events  */}
        <div className="column is-two-fifths">
          <FloatUp>
            <Link to="/admin/events">
              <section className="section block has-background-primary-light">
                <div className="title has-text-centered">
                  <MdEmojiEvents color="gold" /> Events
                </div>
              </section>
            </Link>
          </FloatUp>
        </div>
        {/* Resources */}
        <div className="column is-two-fifths">
          <FloatUp>
            <Link to="/admin/resources">
              <section className="section block has-background-warning-light">
                <div className="title has-text-centered">
                  <RiGalleryFill color="magenta" /> Resources
                </div>
              </section>
            </Link>
          </FloatUp>
        </div>
        {/* Gallery */}
        <div className="column is-two-fifths">
          <FloatUp>
            <Link to="/admin/gallery">
              <section className="section block has-background-success-light">
                <div className="title has-text-centered">
                  <FaRegImages color="green" /> Gallery
                </div>
              </section>
            </Link>
          </FloatUp>
        </div>
        {/* Team */}
        <div className="column is-two-fifths">
          <FloatUp>
            <Link to="/admin/team">
              <section className="section block has-background-info-light">
                <div className="title has-text-centered">
                  <MdGroups color="blue" /> Team
                </div>
              </section>
            </Link>
          </FloatUp>
        </div>
        {/* Trending Youtube links */}
        <div className="column is-two-fifths">
          <FloatUp>
            <Link to="/admin/links">
              <section className="section block has-background-danger-light">
                <div className="title has-text-centered">
                  <FiYoutube color="red" /> Trending Links
                </div>
              </section>
            </Link>
          </FloatUp>
        </div>
        {/* Quotes */}
        <div className="column is-two-fifths">
          <FloatUp>
            <Link to="/admin/quotes">
              <section className="section block has-background-light">
                <div className="title has-text-centered">
                  <BsFillChatQuoteFill color="indigo" /> Quotes
                </div>
              </section>
            </Link>
          </FloatUp>
        </div>
        {/* Announcements */}
        <div className="column is-three-fifths">
          <FloatUp>
            <Link to="/admin/announcements">
              <section className="section block has-background-link-light">
                <div className="title has-text-centered">
                  <GrAnnounce /> Announcements
                </div>
              </section>
            </Link>
          </FloatUp>
        </div>
      </div>
    </div>
  );
}

export default AdminHome;
